module.exports = __webpack_public_path__ + "static/fonts/iconfont.92bb2533.ttf";